export default __webpack_public_path__ + "static/media/chooseLangModalBC.e21ada66.png";